import React, { FunctionComponent, memo } from "react";

interface Button {
  onClick: (item: any) => void,
}

const ButtonCreateConfiguration: FunctionComponent<Button> = memo(({onClick}) =>
  <button className="btn table-btn create-config-btn" onClick={onClick}>configure device</button>);

export default ButtonCreateConfiguration;